import { render } from "./Uom.vue?vue&type=template&id=9b2a604a"
import script from "./Uom.vue?vue&type=script&lang=js"
export * from "./Uom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__